import {Stack, useTheme} from '@mui/material';
import React, {Fragment, useState} from 'react';
import {useSearchParams} from 'react-router-dom';

import {AppointmentBookingEnum} from 'main/analytics/gaTagsEnum';
import {HighlightedText} from 'presentation/components';
import {SearchTermsEnum} from 'presentation/constants/searchTermsEnum';
import {translations} from 'presentation/translations-new';
import {getSpecialtyBySearch} from 'presentation/utils/GetSpecialtyBySearch';
import {SelectCardList, StyledButton, StyledIcon} from './styles';
import {CardListProps} from './types';
import {SpecialtyDetailsDrawer} from '../SpecialtyDetailsDrawer';
import {useFeatureFlag} from 'presentation/hooks/useFeatureFlag';
import {FeaturesEnum} from 'presentation/constants';
import {ONLY_TELEMEDICINE_SPECIALTIES_CODE} from 'presentation/modules/booking/shared/constants/onlyTelemedicineSpecialties';
import {FlowEnum} from '../../constants';
import {OnlyTelemedicineChip} from 'presentation/modules/booking/health/ui/pages/HealthBooking/steps/HealthSpecialtySelection/components/HealthSpecialtiesList/components/OnlyTelemedicineChip';

const {findOutMore} = translations['pt-br'].commons;

export function SpecialtyCard({
	selected,
	text,
	handleClick,
	dataTagId,
	isSuggestionCard,
	showSpecialtyDetailsButton,
	specialtyCode,
	flowType,
	...cardProps
}: CardListProps) {
	const [searchParams] = useSearchParams();
	const {colors} = useTheme();
	const [openDetailsDrawerState, setOpenDetailsDrawerState] = useState(false);
	const specialtyBySearch = getSpecialtyBySearch({
		text: searchParams.get('q') || '',
	});
	const {isEnabled: isOnlyTelemedicineSpecialtyEnabled} = useFeatureFlag(
		FeaturesEnum.PORTAL_FEATURE_SPECIALTY_ONLY_TELEMEDICINE_CHIP,
	);
	const isHealth = flowType === FlowEnum.HEALTH;

	const isHeadacheParams =
		specialtyBySearch?.toLocaleUpperCase() === SearchTermsEnum.DOR_DE_CABECA;

	const query = isHeadacheParams ? searchParams.get('q') || '' : specialtyBySearch;

	const showOnlyTelemedicineChip =
		isOnlyTelemedicineSpecialtyEnabled &&
		isHealth &&
		!isSuggestionCard &&
		ONLY_TELEMEDICINE_SPECIALTIES_CODE.includes(specialtyCode);

	const handleOpenDetailsDrawer = (e?: React.MouseEvent<HTMLButtonElement>) => {
		e?.stopPropagation();
		setOpenDetailsDrawerState(true);
	};

	const handleCloseDetailsDrawer = () => {
		setOpenDetailsDrawerState(false);
	};

	return (
		<Fragment>
			<SelectCardList
				{...cardProps}
				elevation={0}
				selected={selected}
				data-tag-id={dataTagId}
				sx={{cursor: 'pointer'}}
				onClick={handleClick}>
				<Stack p={2} gap={1} direction="row" alignItems="center">
					<Stack gap={0.5}>
						{showOnlyTelemedicineChip ? <OnlyTelemedicineChip /> : null}

						<HighlightedText
							text={text}
							highlight={query}
							dataTagId={
								isSuggestionCard
									? AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_SUGERIDA_TEXT
									: AppointmentBookingEnum.SELECIONOU_ESPECIALIDADE_TEXT
							}
						/>

						{showSpecialtyDetailsButton ? (
							<StyledButton
								data-tag-id={
									AppointmentBookingEnum.CLICK_SABER_MAIS_DESCRICAO_ESPECIALIDADE
								}
								variant="text"
								size="small"
								onClick={handleOpenDetailsDrawer}>
								{findOutMore}
							</StyledButton>
						) : null}
					</Stack>
					<Stack
						flex={1}
						justifyContent={'center'}
						height={'100%'}
						sx={{cursor: 'pointer'}}>
						<StyledIcon
							name="arrow-right"
							size={24}
							color={selected ? colors.light.success.main : colors.brand.primary.blue}
						/>
					</Stack>
				</Stack>
			</SelectCardList>

			{openDetailsDrawerState ? (
				<SpecialtyDetailsDrawer
					isOpen={openDetailsDrawerState}
					onClose={handleCloseDetailsDrawer}
					onOpen={handleOpenDetailsDrawer}
					specialtyName={text}
					specialtyCode={specialtyCode}
				/>
			) : null}
		</Fragment>
	);
}
